module.exports = __webpack_public_path__ + "static/media/image622.a7fb8da6.png";